const FALLBACK = [168, 85, 247];
const parseRgb = value => {
  const channels = String(value || '').trim().split(/\s+/).map(Number);
  return channels.length === 3 && channels.every(channel => Number.isFinite(channel) && channel >= 0 && channel <= 255) ? channels : FALLBACK;
};
const luminance = channels => channels.map(channel => {
  const value = channel / 255;
  return value <= 0.04045 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4;
}).reduce((sum, value, index) => sum + value * [0.2126, 0.7152, 0.0722][index], 0);
export const contrastRatio = (first, second) => {
  const values = [luminance(first), luminance(second)].sort((a, b) => b - a);
  return (values[0] + 0.05) / (values[1] + 0.05);
};
const adjust = (color, toward, background, target) => {
  for (let step = 0; step <= 100; step += 1) {
    const candidate = color.map(channel => Math.round(channel + (toward - channel) * step / 100));
    if (contrastRatio(candidate, background) >= target) return candidate.join(' ');
  }
  return `${toward} ${toward} ${toward}`;
};

// Keep the group's hue, with separate colors for white-on-brand controls and
// brand text on dark surfaces. The margin also covers light grey cards.
export const accessibleBrandColors = primary => {
  const color = parseRgb(primary);
  return {
    primaryRgb: adjust(color, 0, [255, 255, 255], 5.5),
    primaryLightRgb: adjust(color, 255, [63, 63, 70], 4.5),
    primaryDarkRgb: adjust(color, 0, [255, 255, 255], 7),
  };
};
